import { type ListMode as ListModeType } from "@openqlabs/drm-db";

export const ListMode: Record<string, ListModeType> = {
  LIGHT: "LIGHT",
  ULTRALIGHT: "ULTRALIGHT",
  DEEP: "DEEP",
};
